<template>
	<div>
		<PageHeader
			:data="{
				name: 'Clients DNS',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
				],
			}"
		/>

		<!-- Header -->
		<div class="row mb-2" v-if="showClientsList">
			<div class="col-12">
				<div class="alert alert-danger d-flex justify-content-between align-items-center">
					<div>🤯 Be very careful with this ⚡</div>
					<div v-if="lastChange" class="d-flex justify-content-end align-items-center">
						Last change: {{ lastChange.created_at | formatDate }}
						<button @click="revertChangesWindow()" class="btn btn-primary btn-sm fw-normal ms-2">
							Revert back
						</button>
					</div>
					<div v-else>
						There is no previous changes
					</div>
				</div>
			</div>
		</div>

		<!-- Clients List-->
		<div class="row mb-2" v-if="showClientsList">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-md-2">
								<div class="form-group">
									<label for="">Server</label>
									<select v-model="filters.server_ip" class="form-select border-0">
										<option value="">Server not set</option>
										<option value="161.47.89.78">Rackspace RS1</option>
										<option value="138.201.199.88">Hetzner DS3</option>
										<option value="46.4.50.219">Hetzner DS2</option>
										<option value="176.9.158.45">Hetzner DS4</option>
										<option value="162.243.184.78">DigitalOcean DO1</option>
										<option value="34.216.252.96">AWS WEDC</option>
										<option value="104.131.73.154">DigitalOcean DO18</option>
										<option value="18.219.87.118">AWS LS1</option>
									</select>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label for="">DNS Holder</label>
									<select v-model="filters.dns_holder" class="form-select border-0">
										<option value="">All</option>
										<option value="Cloudflare">Cloudflare</option>
										<option value="Name.com">Name.com</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<label for="">Theme</label>
								<select class="form-select border-0" v-model="filters.theme">
									<option value="">Select theme</option>
									<option value="2022 Theme">2022 Theme</option>
									<option value="2022 Mini Theme">2022 Mini Theme</option>
									<option value="TW 2020">TW 2020</option>
									<option value="TW 2019">TW 2019</option>
									<option value="TW 2018">TW 2018</option>
									<option value="Rural Refined">Rural Refined</option>
									<option value="Urban Modern">Urban Modern</option>
									<option value="Reclaimed Modern">Reclaimed Modern</option>
									<option value="NY Super Theme">NY Super Theme</option>
									<option value="Rural Rustic">Rural Rustic</option>
									<option value="The Thrill is Gone - OGv5">The Thrill is Gone - OGv5</option>
									<option value="Custom Design">Custom Design</option>
									<option value="Other">Other</option>
								</select>
							</div>
							<div class="col-md-2 d-flex justify-content-start align-items-end mb-1">
								<button class="btn btn-primary btn-sm fw-normal" @click="applyFilters()">
									Apply filters
								</button>
							</div>
						</div>

						<table class="table" style="height: calc(100vh - 500px);display: block;overflow: auto;">
							<thead>
								<tr>
									<th>
										<input class="form-check-input me-1" v-model="selectAll" @click="toggleSelectAll()" type="checkbox" />
									</th>
									<th>Id</th>
									<th>Name</th>
									<th>Website</th>
									<th>Theme</th>
									<th>DNS Holder</th>
									<th>DNS Holder Id</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="client in filteredClients" :key="client.id">
									<td>
										<input type="checkbox" class="form-check-input me-1" v-model="selectedClients" :value="client.id" />
									</td>
									<td>{{ client.id }}</td>
									<td>{{ client.name }}</td>
									<td>{{ client.website }}</td>
									<td>{{ client.theme }}</td>
									<td>{{ client.dns_holder }}</td>
									<td>{{ client.dns_holder_id }}</td>
								</tr>
							</tbody>
						</table>
						<p>Total filtered: {{ filteredClients.length }}</p>

						<div>
							<button :disabled="selectedClients.length === 0" class="btn btn-primary float-end" @click="confirmSelectedClients()">
								🥷 Manage DNS ({{ selectedClients.length }})
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Manage DNS -->
		<div class="row mb-2" v-if="showManageDns">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<h4>You selected {{ selectedClients.length }} clients to manage DNS</h4>
							<button :disabled="selectedClients.length === 0" class="btn btn-primary float-start" @click="backToClientsList()">
								⬅️ Clients list
							</button>
						</div>
						<div class="mt-4">
							<h5>Choose what action you want to perform</h5>
							<div class="form-check">
								<input class="form-check-input" v-model="dnsAction" type="radio" value="add" id="add" />
								<label class="form-check-label" for="add">
									Add new DNS records
								</label>
							</div>
							<div class="form-check">
								<input class="form-check-input" v-model="dnsAction" type="radio" value="update" id="update" />
								<label class="form-check-label" for="update">
									Update A name records
								</label>
							</div>
						</div>

						<!-- Adding and updating -->
						<div class="mt-4">
							<!-- Add new record-->
							<div v-if="dnsAction === 'add'">
								<div class="alert alert-info">
									🧑‍💻 Adding DNS record <br />
									<small>⚠️ This will add selected DNS record on all selected clients</small>
								</div>
								<div class="row">
									<div class="col-md-8">
										<div class="row">
											<div class="col-md-2">
												<div class="form-group">
													<label for="">Type</label>
													<select v-model="addRecord.type" class="form-select form-select-sm">
														<option value="A">A</option>
													</select>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label for="">Name</label>
													<input type="text" v-model="addRecord.name" placeholder="name" class="form-control form-control-sm" />
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label for="">content</label>
													<input type="text" v-model="addRecord.content" placeholder="content" class="form-control form-control-sm" />
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label for="TTL"></label>
													<input v-model="addRecord.ttl" type="text" placeholder="ttl" class="form-control form-control-sm" />
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-4 d-flex justify-content-end align-items-end">
										<button @click="confirmAdd()" v-if="!addingRecordsLoad" class="btn btn-primary">
											Confirm 👍
										</button>
										<button v-else class="btn btn-primary" type="button" disabled>
											<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
											Loading...
										</button>
									</div>
								</div>
							</div>

							<!-- Edit A name record-->
							<div v-if="dnsAction === 'update'">
								<div class="alert alert-info">
									🧑‍💻 Updating A name record <br />
									<small>⚠️ This will update all A name records ip address for selected clients</small>
								</div>

								<div class="mb-3">
									<a class="" data-bs-toggle="collapse" href="#showClients" role="button" aria-expanded="false" aria-controls="showClients">
										Clients
									</a>
									<div class="collapse" id="showClients">
										<div class="card card-body">
											<div :key="client.id" v-for="client in selectedClients">
												{{ client }}
											</div>
										</div>
									</div>
								</div>

								<div class="d-flex justify-content-between align-items-center">
									<div class="form-group">
										<label for="">Set new server address for all your A name records</label>
										<input type="text" class="form-control" v-model="editRecord.server_ip" />
									</div>
									<button @click="confirmUpdate()" class="btn btn-primary">Confirm 👍</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Revert back -->
		<div class="row mb-2" v-if="showRevert">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<h5>Revert to previous state</h5>
						<p>
							🙋 This action will revers all DNS records affected in last change to previous state. If last action was "Add" then all added record will be removed. If
							last action is update, all DNS records will be updated on previous state.
						</p>
						<div class="change-details">
							<h6>With this revert will be affected {{ lastChange.changes.length }} clients</h6>
							<p class="mb-1">
								A change that has been made in is
								<span class="text-uppercase fw-bold">"{{ lastChange.operation }}"</span> DNS records
							</p>
							<code v-if="lastChange.operation === 'add'">
								Operation: <span class="text-uppercase fw-bold"> {{ lastChange.operation }} </span>
								<br />
								Type: <span class="text-uppercase fw-bold"> {{ lastChange.changes[0].type }} </span>
								<br />
								Name:
								<span class="fw-bold"> {{ lastChange.changes[0].name }} </span> <br />
								Content:
								<span class="text-uppercase fw-bold"> {{ lastChange.changes[0].content }} </span>
							</code>
							<code v-if="lastChange.operation === 'update'">
								Operation: <span class="text-uppercase fw-bold"> {{ lastChange.operation }} </span>
								<br />
								Type: <span class="text-uppercase fw-bold"> A </span>
								<br />
								Content:
								<span class="text-uppercase fw-bold">
									{{ lastChange.changes[0].records[0].old_content }}
								</span>
							</code>
							<div v-if="lastChange.operation === 'add'" class="mt-2">
								⚠️ This operation will remove all DNS records added to clients ({{ lastChange.changes.length }}
								clients)
							</div>
							<div v-else class="mt-2">
								⚠️ This operation will update all DNS records to previous values ({{ lastChange.changes.length }}
								clients)
							</div>
							<div class="mb-3 mt-2" v-if="lastChange.operation === 'add'">
								<a class="" data-bs-toggle="collapse" href="#showClients" role="button" aria-expanded="false" aria-controls="showClients">
									Affected clients list
								</a>
								<div class="collapse mt-2" id="showClients">
									<div class="card card-body">
										<small class="mb-2">
											🧑 This list shows clients with records that will be deleted after the revert
										</small>
										<table class="table">
											<thead>
												<th>Client name</th>
												<th>Type</th>
												<th>Name</th>
												<th>Content</th>
											</thead>
											<tbody>
												<tr :key="change.id" v-for="change in lastChange.changes">
													<td>{{ change.client_name }}</td>
													<td>{{ change.type }}</td>
													<td>{{ change.name }}</td>
													<td>{{ change.content }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div class="mb-3 mt-2" v-if="lastChange.operation === 'update'">
								<a class="" data-bs-toggle="collapse" href="#showClients" role="button" aria-expanded="false" aria-controls="showClients">
									Affected clients list
								</a>
								<div class="collapse mt-2" id="showClients">
									<div class="card card-body">
										<small class="mb-2">
											🧑 This list shows clients with they records that will be reverted to previous value
										</small>

										<div :key="change.client_id" v-for="change in lastChange.changes">
											<div class="row py-1 shadow-sm mb-1" :key="record.id" v-for="record in change.records">
												<div class="col-md-4">
													{{ change.client_name }}
												</div>
												<div class="col-md-4">
													{{ record.name }}
												</div>
												<div class="col-md-4 d-flex justify-content-end">
													<span class="text-danger me-3">{{ record.new_content }}</span>
													➡️
													<span class="text-success ms-3 fw-bold">{{ record.old_content }}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="actions d-flex justify-content-end">
							<button class="btn btn-default me-1" @click="revertChangesWindowClose()">
								Cancel
							</button>
							<button class="btn btn-primary me-1" @click="revertChanges()">
								🕜 Revert
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Report -->
		<div class="row mb-2" v-if="showReport">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<h5 class="mb-3" v-if="dnsAction === 'add'">Adding DNS record report</h5>
						<h5 class="mb-3" v-else>Updating DNS records report</h5>

						<!-- Add Dns records report -->
						<div class="row mt-3 mb-0" v-if="reportChanges.length > 0 && reportOperation === 'add'">
							<div class="col-md-4">
								<h6>Client</h6>
							</div>
							<div class="col-md-4">
								<h6>Website</h6>
							</div>
							<div class="col-md-4">
								<h6>Status/Records</h6>
							</div>
						</div>

						<div class="changes-list" v-if="reportChanges.length > 0 && reportOperation === 'add'">
							<div class="row mb-3 border-bottom pb-1" :key="change.dns_record_id" v-for="change in reportChanges">
								<div class="col-md-4">
									<a target="_blank" :href="'/clients/edit/' + change.client_id">
										{{ change.client_name }}
									</a>
								</div>
								<div class="col-md-4">
									{{ change.website }}
								</div>
								<div
									class="col-md-4 "
									:class="{
										'text-success': change.status.includes('Successfully'),
										'text-danger': !change.status.includes('Successfully'),
									}"
								>
									{{ change.status }}
								</div>
							</div>
						</div>

						<!-- Update DNS records report -->
						<div class="changes-list" v-if="reportChanges.length > 0 && reportOperation === 'update'">
							<div class="row" :key="change.dns_record_id" v-for="change in reportChanges">
								<div class="col-md-12">
									<div :key="record.id" v-for="record in change.records" class="card mb-2">
										<div class="card-body d-flex justify-content-between p-2">
											<div>
												Client <br />
												<span class="fw-bold">
													<a target="_blank" :href="'/clients/edit/' + change.client_id">
														{{ change.client_name }}
													</a>
												</span>
											</div>
											<div>
												Type <br />
												<span class="fw-bold">{{ record.type }}</span>
											</div>
											<div>
												Name <br />
												<span class="fw-bold">{{ record.name }}</span>
											</div>
											<div>
												Content <br />
												<span>{{ record.new_content }}</span>
											</div>
											<div>
												Status <br />
												<span
													:class="{
														'text-success': record.status.includes('Successfully'),
														'text-danger': !record.status.includes('Successfully'),
													}"
													>{{ record.status }}</span
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="actions d-flex justify-content-between mt-3">
							<button disabled class="btn btn-success">Export Report (Coming soon)</button>
							<button class="btn btn-secondary" @click="reportWindowClose()">
								Close
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Loading -->
		<div class="row mb-2" v-if="loading">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body text-center">
						<h5>{{ loadingMessage }}</h5>
						<div class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import restApi from '../../api'
import { handleErrors } from '../../actions/helpers'
import { mapState } from 'vuex'
export default {
	name: 'ClientsDns',
	components: { PageHeader },
	data() {
		return {
			filters: {
				dns_holder: '',
				theme: '',
				server_ip: '161.47.89.78',
			},
			clients: [],
			filteredClients: [],
			selectedClients: [],
			selectAll: false,
			updateDns: false,
			addDns: false,
			manageDns: false,
			dnsAction: '',
			editRecord: {
				server_ip: '',
			},
			addRecord: {
				name: '',
				type: 'A',
				content: '161.47.89.78',
				ttl: '',
			},
			selectedDetails: '',
			lastChange: null,
			loadReverting: false,
			revertingDone: false,
			addingRecordsLoad: false,
			reportChanges: [],
			showClientsList: true,
			showManageDns: false,
			showRevert: false,
			showReport: false,
			loading: false,
			loadingMessage: 'Testing Loading Message',
			reportOperation: '',
		}
	},
	computed: {
		...mapState(['authUser']),
	},
	created() {
		if (this.authUser.email == 'srdjank90@gmail.com' || this.authUser.email == 'ivan@townweb.com') {
			this.getClients()
			this.getLastDnsChange()
		} else {
			this.$router.push('/')
		}
	},

	mounted() {},

	watch: {
		selectedClients: function() {
			this.selectedDetails = this.selectedClients.length
		},
	},

	methods: {
		// Get clients
		getClients() {
			restApi
				.get(`clients/dns-clients`)
				.then(({ data }) => {
					this.clients = data
					this.filteredClients = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Apply filters
		applyFilters() {
			this.filteredClients = this.clients
			// DNS Holder filter
			if (this.filters.dns_holder !== '') {
				this.filteredClients = this.filteredClients.filter(client => {
					return client.dns_holder === this.filters.dns_holder
				})
			} else {
				this.filteredClients = this.clients
			}

			// Theme filter
			if (this.filters.theme !== '') {
				this.filteredClients = this.filteredClients.filter(client => {
					return client.theme === this.filters.theme
				})
			}
		},

		// Select/Deselect all
		toggleSelectAll() {
			this.selectedClients = []
			if (!this.selectAll) {
				this.filteredClients.forEach(client => {
					this.selectedClients.push(client.id)
				})
			}
		},

		confirmUpdate() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'This action will edit all A name records of selected clients!',
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Confirm',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						this.loading = true
						this.loadingMessage = 'Updating A name records for selected clients ...'
						this.showManageDns = false
						restApi
							.post(`/dns-records/multi-update`, {
								clients: this.selectedClients,
								record: this.editRecord,
							})
							.then(({ data }) => {
								console.log(data)
								if (data.operation === 'update') {
									let changes = JSON.parse(data.changes)
									this.reportChanges = changes
									this.reportOperation = 'update'
								} else {
									let changes = JSON.parse(data.changes)
									this.reportChanges = changes
									this.reportOperation = 'add'
								}

								this.loading = false
								this.showManageDns = false
								this.showReport = true
								this.$swal.fire({
									icon: 'success',
									title: 'DNS records successfully updated!',
								})
							})
							.catch(error => {
								this.loading = false
								this.$swal.fire({
									icon: 'error',
									title: error.response.data.message,
									timer: 6000,
								})
							})
					}
				})
		},

		// Confirm adding new DNS to clients
		confirmAdd() {
			if (this.addRecord.name === '') {
				this.$swal.fire({
					icon: 'error',
					title: 'You need to add name for record',
					timer: 3000,
				})
			} else if (this.addRecord.content === '') {
				this.$swal.fire({
					icon: 'error',
					title: 'Content field cannot be empty',
					timer: 3000,
				})
			} else {
				this.$swal
					.fire({
						title: 'Are you sure?',
						text: 'This action will add record to all selected clients!',
						icon: 'warning',
						position: 'center',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Confirm',
						toast: false,
						timer: 0,
					})
					.then(result => {
						if (result.isConfirmed) {
							this.loading = true
							this.loadingMessage = 'Adding DNS record for selected clients ...'
							this.showManageDns = false
							restApi
								.post(`/dns-records/multi-add`, {
									clients: this.selectedClients,
									record: this.addRecord,
								})
								.then(({ data }) => {
									console.log(data)
									this.reportChanges = data
									this.reportOperation = 'add'
									this.getLastDnsChange()
									this.loading = false
									this.showManageDns = false
									this.showReport = true
									this.$swal.fire({
										icon: 'success',
										title: 'Dns records successfully added!',
									})
								})
								.catch(error => {
									this.loading = false
									this.$swal.fire({
										icon: 'error',
										title: error.response.data.message,
										timer: 6000,
									})
								})
						}
					})
			}
		},

		// Get last DNS change to make revert
		getLastDnsChange() {
			restApi
				.get(`dns-records/last-change`)
				.then(({ data }) => {
					this.lastChange = data
					this.lastChange.changes = JSON.parse(data.changes)
				})
				.catch(() => {
					this.lastChange = null
				})
		},

		// Revert changes
		revertChanges() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'All records will be returned to previous state. Added records will be deleted!',
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Confirm',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						this.loading = true
						this.showRevert = false
						this.loadingMessage = 'Reverting changes to previous state ...'
						restApi
							.post(`dns-records/revert-change`)
							.then(({ data }) => {
								console.log(data)
								this.reportChanges = data.changes
								this.reportOperation = data.operation
								this.loading = false
								this.showReport = true
								this.getLastDnsChange()
								this.$swal.fire({
									icon: 'success',
									title: 'Revert successfully done',
									timer: 2500,
								})
							})
							.catch(error => {
								this.loading = false
								this.$swal.fire({
									icon: 'error',
									title: error.response.data.message,
									timer: 6000,
								})
							})
					}
				})
		},

		// Close modal when reverting is done
		closeRevertingWindow() {
			this.revertingDone = false
			this.$revertModal.hide()
		},

		// Confirm selected clients for DNS change
		confirmSelectedClients() {
			this.showClientsList = false
			this.showManageDns = true
		},

		// Back to clients list
		backToClientsList() {
			this.showClientsList = true
			this.showManageDns = false
		},

		// Open revert window
		revertChangesWindow() {
			this.showRevert = true
			this.showClientsList = false
		},

		// Close revert window
		revertChangesWindowClose() {
			this.showRevert = false
			this.showClientsList = true
		},

		// Close report window
		reportWindowClose() {
			this.showReport = false
			this.showClientsList = true
			this.lastChange = null
			this.selectedClients = []
			this.getLastDnsChange()
		},
	},

	filters: {
		// Format date
		formatDate: function(value) {
			if (!value) return ''
			value = value.toString()
			var x = new Date(value)
			var dd = x.getDate()
			var mm = x.getMonth() + 1
			var yy = x.getFullYear()
			var hh = x.getHours()
			var min = x.getMinutes()
			return dd + '.' + mm + '.' + yy + ' | ' + hh + ':' + min
		},
	},
}
</script>
